export default "__VITE_ASSET__BbiJXBRw__"